//RITM1230723
import React, { Component } from "react";

import Data16 from "@carbon/icons-react/lib/data--1/16";
import PageBreadCrumb from "./../../helpers/PageBreadCrumb";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import { AppContext } from "./../../helpers/context/AppContext";
import { ComboBox } from "../../helpers/ComboBox";
import { ConfirmAlertCustom } from "./../../helpers/ConfirmAlertCustom";
import { Download16, Add16, Edit16, Delete16 } from "@carbon/icons-react";
import { Online } from "./../common/OnLineOffLine";
import { RenderDataTableCell, NoRecordsPlaceholder } from "../../helpers/jsonschemaform/DataTableExtention";
import {
	Search,
	TableToolbar,
	Loading,
	Button,
	Form,
	FormGroup,
	FormLabel,
	TextInput,
	DataTable,
	TableContainer,
	DataTableSkeleton,
	Pagination,
	Table,
	TableHead,
	TableRow,
	TableHeader,
	TableBody,
	TableCell,
	ComposedModal,
	ModalHeader,
	ModalBody,
	DropdownSkeleton,
	MultiSelect,
	TextArea,
} from "carbon-components-react";
import { api, dynamic } from "./../../helpers/api/api";
import { entitiesLabels, apioperation, getError, getSuccess, DateFormat } from "../../helpers/Constants";
import { showNotification } from "./../../helpers/notification/BaseNotification";
import { v4 as uuid } from "uuid";
import _sortBy from 'lodash/sortBy';
import DateTimePicker from '../../helpers/DateTimePicker';

const searchProp = {
	section: null,
	description: null,
};

const modelProp = {
	id: undefined,
	code: null,
	section: null,
	description: null,
	frequency: null,
	months: null,
	validSince: null,
	validUntil: null,
	ranking: null,
	incidentBarriers: null,
	incidentBarrierGroups: null,
	barrierKPIBarriers: [],
	barrierKPIInfoOriginators: [],
	barrierGroups: [],
};

const frequencies = ["Monthly", "Quarterly", "Custom"];
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export class BarrierKPI extends Component {
	constructor(props) {
		super(props);
		this.validator = new SimpleReactValidator();
		this.state = {
			// Paging
			currentPage: 1,
			pageSize: 10,
			rowCount: 0,

			// Loaders
			isExportLoading: false,
			isLoadingEntity: false,
			isSearchFormExpanded: false,

			// Search-related fields
			search: { ...searchProp },

			// Edit modal
			isUpdateMode: false,
			isEditModalOpen: false,

			// Insert / edit model
			model: { ...modelProp },

			// Delete
			idToDelete: null,
			isDeleting: false,
			isDeleteModalOpen: false,

			// Used for update
			oldIdKpi: null,
			oldYear: null,
			oldQuarter: null,
			oldIdDivision: null,
			appIncidentBarrierGroup: [],
			appIncidentBarrier: [],
			appInfoOriginator: [],
			loading: false,
			reportBarrierKPIListPaged: [],
			reportBarrierKPIListAll: [],
		};
	}

	componentDidMount() {
		this.setState({ loading: true });
		this.getIncidentBarrierGroup();
		this.getIncidentBarrier();
		this.getInfoOriginators();
		this.getAllReportBarrierKpis();

		// Main list
		this.getPagedFilteredReportBarrierKpis();
		this.setState({ loading: false });
	}

	getPagedFilteredReportBarrierKpis = (param) => {
		this.setState({ isLoadingEntity: true });

		const filter = {
			page: param && param.page ? param.page : this.state.currentPage,
			pageSize: param && param.pageSize ? param.pageSize : this.state.pageSize,
			section: this.state.search.section,
			description: this.state.search.description,
		};

		const data = { params: { ...filter } };

		api
			.getWithParam('/reports/reportbarrierkpis', data)
			.then((res) => {
				if (res.status === 200) {
					const { data } = res;
					this.setState({
						currentPage: data.currentPage,
						pageSize: data.pageSize,
						rowCount: data.rowCount,
						reportBarrierKPIListPaged: data.itemList,
					});
				} else {
					showNotification.error();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.REPORTBARRIERKPIINPUT, apioperation.GET));
			})
			.finally(() => {
				this.setState({ isLoadingEntity: false });
			});
	};

	getAllReportBarrierKpis = () => {
		api
			.getAll('/reports/report-barrier-kpi/all')
			.then((res) => {
				if (res.status === 200) {
					this.setState({ reportBarrierKPIListAll: res.data });
				} else {
					showNotification.error();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.REPORTBARRIERKPIINPUT, apioperation.GET));
			})
			.finally(() => {});
	};

	getIncidentBarrierGroup = async () => {
		await dynamic
		  .getAll('incidentbarriergroup', { params: { page: 0 } })
		  .then((response) => {
			const databarrierGroup = _sortBy(
				(response.data.itemList || []).filter((el) =>  (el.inUse) 
					|| (this.state.model.barrierGroups > 0 ? this.state.model.barrierGroups?.find((elem) => elem.id === el.id) : true)),
				'ranking'
			  );
			this.setState({
				appIncidentBarrierGroup: databarrierGroup,
			});
		  })
		  .catch((error) => {
			showNotification.error(
			  `${entitiesLabels.ERROR}`,
			  getError(error, entitiesLabels.BARRIERGROUP, apioperation.GET)
			);
		  })
		  .finally(() => {});
	  };

	getIncidentBarrier =  async (selectedBarrierGroups) => {
		await dynamic
		  .getAll('incidentbarrier', { params: { page: 0 } })
		  .then((response) => {
			if(selectedBarrierGroups == undefined)
			{
				const dataBarrier = _sortBy(
					(response.data.itemList || []).filter((el) => (selectedBarrierGroups != null 
						? selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup): true) && ((el.inUse && (this.state.model.barrierKPIBarriers > 0 ? (this.state.model.barrierKPIBarriers?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup) : true))
						|| (this.state.model.barrierKPIBarriers > 0 ? (this.state.model.barrierKPIBarriers?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup) : true))),
					[(p) => p.ranking, (p) => p.name?.toLowerCase()]
				  );
				this.setState({
					appIncidentBarrier: dataBarrier,
				});
			}
			else
			{
				const dataBarrier = _sortBy(
					(response.data.itemList || []).filter((el) => (selectedBarrierGroups != null 
						? selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup): true) && ((el.inUse) 
						|| (this.state.model.barrierKPIBarriers > 0 ? (this.state.model.barrierKPIBarriers?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup) : true))),
					[(p) => p.ranking, (p) => p.name?.toLowerCase()]
				  );
				this.setState({
					appIncidentBarrier: dataBarrier,
				});
			}
		  })
		  .catch((error) => {
			showNotification.error(
			  `${entitiesLabels.ERROR}`,
			  getError(error, entitiesLabels.BARRIER, apioperation.GET)
			);
		  })
		  .finally(() => {});
	  };

	getInfoOriginators = () => {  
		dynamic
		.getAll('infooriginator', { params: { page: 0 } }) 
		.then((response) => {
		  const data = _sortBy(
			(response.data.itemList || []).filter((el) =>  (el.inUse) 
				|| (this.state.model.barrierKPIInfoOriginators > 0 ? this.state.model.barrierKPIInfoOriginators?.find((elem) => elem.id === el.id) : true)),
			'id'
		  );
		  this.setState({
			appInfoOriginator: data,
		  });
		})
		.catch((error) => {
		  showNotification.error(
			`${entitiesLabels.ERROR}`,
			getError(error, entitiesLabels.INFOORIGINATOR, apioperation.GET)
		  );
		})
		.finally(() => {});
	};

	// Modals
	openAddNewModal = () => {
		this.setState({
			isUpdateMode: false,
			isEditModalOpen: true,
		});
	};

	closeEditModal = () => {
		this.setState({
			model: { ...modelProp },
			isEditModalOpen: false,
		});
		this.validator.hideMessages();
	};

	// Search
	toggleSearchForm = (e) => {
		e.preventDefault();
		this.setState((oldState) => ({ isSearchFormExpanded: !oldState.isSearchFormExpanded }));
	};

	handleClickCancelSearch = (e) => {
		e.preventDefault();
		this.setState(
			{
				search: { ...searchProp },
				isSearchFormExpanded: false,
			},
			() => {
				this.getPagedFilteredReportBarrierKpis({ page: 1 });
			}
		);
	};

	handleClickSearch = (e) => {
		e.preventDefault();
		this.getPagedFilteredReportBarrierKpis({ page: 1 });
	};

	// Excel export
	downloadFile() {
		if (this.state.isExportLoading) return;

		this.setState({ isExportLoading: true });

		api.getWithParam("/reports/downloadexcel", { responseType: "arraybuffer" })
			.then((response) => {
				var data = new Blob([response.data], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});
				var csvURL = window.URL.createObjectURL(data);
				var tempLink = document.createElement("a");
				tempLink.href = csvURL;

				var fileName = "Export_" + "ReportBarrierKPI_" + moment().format("YYYYMMDDHHmmSS") + ".xlsx";
				tempLink.setAttribute("download", fileName);

				document.body.appendChild(tempLink);
				tempLink.click();
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "Download File", apioperation.GET));
			})
			.finally(() => {
				this.setState({ isExportLoading: false });
			});
	}

	// Search form handlers
	updateStateSearch = (inputName, inputValue, objName) => {
		const stateCopy = { ...this.state.search };
		stateCopy[inputName] = inputValue;
		this.setState({ search: stateCopy });
	};

	handleChangeModelFrequency = (inputName, selectedItem, objName) => {
		const inputValue = selectedItem ? selectedItem : null;
		const stateCopy = { ...this.state };

		stateCopy[objName][inputName] = inputValue;
		this.setState(stateCopy);
	};

	handleChangeModel = (el) => {
		let inputName = el.target.name;
		let inputValue = el.target.value;
		this.updateState(inputName, inputValue, 'model');
	};

	handleIncidentBarrier = (items, property) => {
		const statusCopy = { ...this.state.model };
        if(property == 'barrierGroups')
        {
            const newBarrierGroups = []
            const newBarrierKPIBarriers = []
            items.forEach((barrierGroup) => {
                newBarrierGroups.push({
                    ...barrierGroup
                })
            })
            
            const barrierKPIBarriers = statusCopy.barrierKPIBarriers?.filter(x => items.find(el => el.id == x?.incidentBarrier?.idIncidentBarrierGroup)).map(elem => ({incidentBarrier: elem.incidentBarrier})) 
            if (barrierKPIBarriers && barrierKPIBarriers.length > 0)
                barrierKPIBarriers.forEach((barrierKPIBarrier) => {
                    newBarrierKPIBarriers.push({
                            ...barrierKPIBarrier
                        })
                    })
			statusCopy[property] = [...newBarrierGroups]
            statusCopy['barrierKPIBarriers'] =[...newBarrierKPIBarriers]
        }
        else if (property == 'barrierKPIBarriers')
        {
            const newBarrierKPIBarriers = []
            const newBarrierGroups = []
            items.forEach((barrier) => {
				newBarrierKPIBarriers.push({
                        ...barrier
                    })
                })


            const barrierGroups = statusCopy.barrierGroups?.filter(x => items.find(el => el.incidentBarrier.idIncidentBarrierGroup == x.id)).map(elem => elem) 
            if (barrierGroups && barrierGroups.length > 0)
                barrierGroups.forEach((barrierGroup) => {
                    newBarrierGroups.push({
                                ...barrierGroup
                            })
                        })

			statusCopy[property] = [...newBarrierKPIBarriers]
            statusCopy['barrierGroups'] =[...newBarrierGroups]      
        }
        this.setState({ model: statusCopy })
    };

	handleInfoOriginator = (items, property) => {
		const statusCopy = { ...this.state.model };
		const newInfoOriginators = []
		items.forEach((InfoOriginator) => {
			newInfoOriginators.push({
				...InfoOriginator
			})
		})
		statusCopy[property] = [...newInfoOriginators]
		this.setState({ model: statusCopy })
	};

	handleChangeSearch = (el, property) => {
		let inputName = el.target.name;
		let inputValue = el.target.value;
		this.updateStateSearch(inputName, inputValue, property);
	};

	onChangeBarrierGroup = (selectedItem) => {
		const items = selectedItem ? selectedItem.selectedItems : null;
		this.getIncidentBarrier(items?.map((elem) =>({idIncidentBarrierGroup: elem.id})));
		this.handleIncidentBarrier(items, "barrierGroups");
	};

	onChangeBarrier = (selectedItem) => {
		const items = selectedItem ? selectedItem.selectedItems : null;
		this.getIncidentBarrier(items?.map((elem) =>({idIncidentBarrierGroup: elem.idIncidentBarrierGroup})));
		const element = items?.map((elem) =>({incidentBarrier: elem}))
		this.handleIncidentBarrier(element, "barrierKPIBarriers");
	};

	onChangeMonths = (inputName, selectedItems, objName) => {
		const element = selectedItems?.map((elem) => elem).join(', ');
		this.updateState(inputName, element, objName);
	};

	onChangeInfoOriginators = (selectedItem) => {
		const items = selectedItem ? selectedItem.selectedItems : null;
		const element = items?.map((elem) =>({infoOriginator: elem}))
		this.handleInfoOriginator(element, "barrierKPIInfoOriginators");
	};


	returnIncidentBarriers = (id, property) =>	{
		if(property === "BarrierGroup") 
			return this.state.model.barrierGroups?.find(el => el.id === id) ? true : false;
		else if(property === "Barrier") 
			return this.state.model.barrierKPIBarriers?.find(el => el.incidentBarrier.id === id) ? true : false;
	}

	// Edit modal insertion
	insertReportBarrierKPI = () => {
		if (this.validator.allValid()) {
			this.setState({
				isSubmitted: true,
			});

			const formData = this.state?.model;
			if (!this.state.isUpdateMode) {
				formData.id = uuid();
			}

			const method = this.state.isUpdateMode ? api.put('/reports/report-barrier-kpi/edit/', formData) : api.post('/reports/create-report-barrier-kpi', formData);

			method
				.then(async (response) => {
					if (response.status === 200) {
						showNotification.success(`${entitiesLabels.SUCCESS}`, "Successfully saved");
						this.setState(
							{
								isLoading: false,
							},
							this.closeEditModal
						);
					} else {
						showNotification.error(`${entitiesLabels.ERROR}`, getError("Unsuccessfully saved", entitiesLabels.KPIMANUALINPUT, apioperation.POST));
					}
				})
				.catch((error) => {
					showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.KPIMANUALINPUT, apioperation.POST));
				})
				.finally(() => {
					this.setState(
						{
							isLoading: false,
						},
						() => {
							this.getPagedFilteredReportBarrierKpis();
							this.getAllReportBarrierKpis();
							this.forceUpdate();
						}
					);
				});
		} else {
			this.validator.showMessages();
			showNotification.warning(`${entitiesLabels.WARNING}`, `${entitiesLabels.REPORTBARRIERKPIINPUT} required fields are missing  `);
			this.forceUpdate();
		}
	};

	// Edit modal update
	getReportBarrierKPIForEdit = (id) => {
		this.setState({
			isUpdateMode: true,
			isEditModalOpen: true,
		});
		this.getIncidentBarrierGroup();
		this.getIncidentBarrier();
		this.getInfoOriginators();
		let reportBarrierKPIToChange = this.state.reportBarrierKPIListPaged.find((x) => x.id == id);
		this.setState({
			model: reportBarrierKPIToChange,
		});
	};

	updateState = (inputName, inputValue, objName) => {
		const statusCopy = { ...this.state.model };
		if (objName && objName != "model") statusCopy[objName][inputName] = inputValue;
		else statusCopy[inputName] = inputValue;

		this.setState({ model: statusCopy });
	};

	// Delete modal
	confirmDelete = (id) => {
		this.setState({
			idToDelete: id,
			isDeleteModalOpen: true,
			isDeleting: false,
		});
	};

	deleteItem = () => {
		let id = this.state.idToDelete;
		this.setState({ isDeleting: true });
		const formData = this.state.reportBarrierKPIListPaged.find((x) => x.id === id);

		api
			.deleteData('/reports/report-barrier-kpi/delete/', formData)
			.then((response) => {
				if (response.status === 200) {
					this.setState({
						idToDelete: null,
						isDeleteModalOpen: false,
					});
					this.onCloseConfirm();
					this.getPagedFilteredReportBarrierKpis();
					this.getAllReportBarrierKpis();
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.REPORTBARRIERKPIINPUT, apioperation.DELETE));
				} else {
					showNotification.error();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.REPORTBARRIERKPIINPUT, apioperation.DELETE));
			})
			.finally(() => {
				this.setState({ isDeleting: false });
			});
	};

	onCloseConfirm = () => {
		this.setState({ isDeleteModalOpen: false });
	};

	// Render methods
	renderSearchForm = () =>
		this.state.isSearchFormExpanded && (
			<div>
				<Form autoComplete="off" className="bx--row" onSubmit={this.handleClickSearch}>
					<FormGroup legendText="" className="bx--col-md-4">
						<FormLabel>Section</FormLabel>
						<TextInput
							id="inputsection"
							name="section"
							value={this.state.search.section}
							onChange={(e) =>
								this.handleChangeSearch(e, 'section')
							  }
							placeholder="Input Section"
							type="text"
							labelText=""
							className="bx--text-input some-class bx--text-input--light"
						/>
            		</FormGroup>
					<FormGroup legendText="" className="bx--col-md-4">
						<FormLabel>KPI description</FormLabel>
						<TextInput
							id="inputdescription"
							name="description"
							value={this.state.search.description}
							onChange={(e) =>
								this.handleChangeSearch(e, 'description')
							  }
							placeholder="Input KPI Description"
							type="text"
							labelText=""
							className="bx--text-input some-class bx--text-input--light"
						/>
            		</FormGroup>
				</Form>
				<div className="searchFormFooter">
					<Button className="button--max-width" size="small" kind="secondary" onClick={this.handleClickCancelSearch}>
						Cancel
					</Button>
					<Button className="button--max-width" size="small" onClick={this.handleClickSearch}>
						Search
					</Button>
				</div>
			</div>
		);

	renderDetailsForm() {
		const modalHeader = {
			title: (this.state.isUpdateMode ? "Edit " : "Add new ") + "Barrier KPI",
			iconDescription: "Close",
			buttonOnClick: () => this.closeEditModal(),
		};

		const validations = {
			code: this.validator.message("Code", this.state.model.code, "required"),
			section: this.validator.message("Section", this.state.model.section, "required"),
			barrierGroup: this.validator.message("Barrier Group", this.state.model.barrierGroups[0], "required"),
			barrier: this.validator.message("Barrier", this.state.model.barrierKPIBarriers[0], "required"),
			description: this.validator.message("Description", this.state.model.description, "required"),
			validSince: this.validator.message('Valid Since', this.state.model.validSince, 'required'),
			validUntil: this.validator.message('Valid Until', this.state.model.validUntil, 'required'),
			endAfterStart: this.validator.message(
				'endAfterStart',
				this.state.model.validUntil == null ||
				  this.state.model.validSince == null ||
				  moment(this.state.model.validUntil).isSameOrAfter(
					moment(this.state.model.validSince),
					'day'
				  ),
				'accepted'
			  ),
			ranking: this.validator.message('Ranking', this.state.model.ranking, 'required|integer'),
			frequency: this.validator.message('Frequency', this.state.model.frequency, 'required'),
			months: this.validator.message('Months', this.state.model.frequency === "Custom" &&  this.state.model.months, 'required'),
			infoOriginator: this.validator.message("Employer Type", this.state.model.barrierKPIInfoOriginators[0], "required"),
			rankinggeq: this.validator.message(
				'rankinggeq',
				this.state.model.ranking >= 0,
				'accepted'
			  ),
		};

		return (
			<ComposedModal className="light-modal" open={this.state.isEditModalOpen} danger="false" onClose={() => this.closeEditModal()}>
				<ModalHeader className="margin-modal" {...modalHeader} />
				<ModalBody className="margin-modal margin-modal-content">
					<Form className="bx--grid--full-width">
						<div className="bx--row">
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Code*</FormLabel>
									<TextInput
										id="modelcode"
										name="code"
										placeholder="Input code"
										required
										value={this.state.model.code}
										onChange={this.handleChangeModel}
										invalid={validations.code != null}
										type="text"
										labelText=""
										className="bx--text-input  bx--text-input--light"
										disabled={false}
									/>
									{validations.code}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Section*</FormLabel>
									<TextInput
										id="modelsection"
										name="section"
										placeholder="Input section"
										required
										value={this.state.model.section}
										onChange={this.handleChangeModel}
										invalid={validations.section != null}
										type="text"
										labelText=""
										className="bx--text-input  bx--text-input--light"
										disabled={false}
									/>
									{validations.section}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Barrier Group*</FormLabel>
								{this.state.isLoadingEntity ? (
											<DropdownSkeleton />
											) : (
												<MultiSelect.Filterable
														id={"modelBarrierGroup"}
														key={"modelBarrierGroup_" + Math.random()}
														invalid={validations.barrierGroup != null}
														invalidText={validations.barrierGroup}
														disabled={false}
														placeholder={this.state.model.barrierGroups < 1 ? 'Choose one or more barrier groups' : this.state.model.barrierGroups?.map((el) => el.name).join(', ')}
														itemToString={(item) => (item ? item && item.name : '')}
														items={ this.state.appIncidentBarrierGroup }
														light={false}
														onChange={this.onChangeBarrierGroup}
														type="default"
														sortItems={(items) => items}
														initialSelectedItems ={(this.state.appIncidentBarrierGroup || []).filter((el) => this.returnIncidentBarriers(el.id, "BarrierGroup"))}
												/>
										)} 
							</FormGroup>
							 <FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Barriers*</FormLabel>
								{this.state.isLoadingEntity ? (
											<DropdownSkeleton />
											) : (
												<MultiSelect.Filterable
														id={"modelBarrier"}
														key={"modelBarrier_" + Math.random()}
														invalid={validations.barrier != null}
														invalidText={validations.barrier}
														disabled={this.state.model.barrierGroups < 1}
														placeholder={
															(this.state.model.barrierKPIBarriers < 1 
																? 'Choose one or more barriers'
																: this.state.model.barrierKPIBarriers?.map((el) => el.incidentBarrier.name).join(', '))
														}
														itemToString={(item) => (item ? item && item.name : '')}
														items={this.state.appIncidentBarrier}
														light={false}
														onChange={this.onChangeBarrier}
														type="default"
														sortItems={(items) => items}
														initialSelectedItems ={(this.state.appIncidentBarrier|| []).filter((e) => this.returnIncidentBarriers(e.id, "Barrier"))}
													/>
											)} 
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>KPI Description*</FormLabel>
									<TextArea
										id="modeldescription"
										name="description"
										placeholder="Input KPI description"
										required
										value={this.state.model.description}
										onChange={this.handleChangeModel}
										invalid={validations.description != null}
										type="text"
										labelText=""
										disabled={false}
										rows={4}
										cols={225}
									/>
									{validations.description}
								</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Valid Since*</FormLabel>
									<DateTimePicker
										value={this.state.model.validSince}
										type="date"
										placeholder={DateFormat}
										name="validSince"
										alt="model"
										invalid={validations.validSince != null}
										onChange={this.updateState}
									/>
									{validations.validSince}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Valid Until*</FormLabel>
									<DateTimePicker
										value={this.state.model.validUntil}
										type="date"
										placeholder={DateFormat}
										name="validUntil"
										alt="model"
										invalid={validations.validUntil != null}
										onChange={this.updateState}
									/>
									{validations.validUntil}
									{validations.endAfterStart && (
										<div className="srv-validation-message">
										The valid until field must be after valid since field
										</div>
									)}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Ranking*</FormLabel>
									<TextInput
										id="modelranking"
										name="ranking"
										value={this.state.model.ranking}
										onChange={this.handleChangeModel}
										type="number"
										min="0"
										step="1"
										placeholder=""
										onKeyDown={(e) => /[\+\-\.\,]$/.test(e.key) && e.preventDefault()}
										disabled={false}
										invalid={validations.ranking != null}
									/>
									{validations.ranking}  
									{validations.rankinggeq && (
										<div className="srv-validation-message">
										The value must be greater than or equal to zero
										</div>
									)}                         
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Frequency*</FormLabel>
									<ComboBox
										key={"modelfrequency" + this.state.model.frequency}
										id="modelfrequency"
										placeholder=""
										name="frequency"
										alt="model"
										onChange={this.handleChangeModelFrequency}
										itemToString={(item) => item || ""}
										initialSelectedItem={this.state.model.frequency || []}
										items={frequencies}
										direction="bottom"
										disabled={false}
										invalid={validations.frequency != null}
									/>
									{validations.frequency}
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Months*</FormLabel>
									<MultiSelect
										id={"modelMonth"}
										key={"modelMonth_" + Math.random()}
										label={
											this.state.model.months
											  ? this.state.model.months
											  : 'Choose one or more items'
										  }
										multiCombo
										name="months"
										alt="model"
										invalid={validations.months != null}
										invalidText={validations.months}
										disabled={this.state.model.frequency !== "Custom" }
										itemToString={(item) => (item ? item : '')}
										items={months}
										light={false}
										sortItems={(items) => items}
										onChange={(months) =>
											this.onChangeMonths('months', months.selectedItems, 'model')
										  }
										initialSelectedItems ={(months || []).filter((e) => this.state.model.months !== null ? this.state.model.months.split(', ').find((el) => el == e) : false)}
										>
											{' '}
									</MultiSelect>					
							</FormGroup>
							<FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
								<FormLabel>Employer Type*</FormLabel>
								{this.state.isLoadingEntity ? (
											<DropdownSkeleton />
											) : (
												<MultiSelect.Filterable
														id={"modelInfoOriginator"}
														key={"modelInfoOriginator_" + Math.random()}
														invalid={validations.infoOriginator != null}
														invalidText={validations.infoOriginator}
														disabled={false}
														placeholder={
															(this.state.model.barrierKPIInfoOriginators < 1 
																? 'Choose one or more employer types'
																: this.state.model.barrierKPIInfoOriginators.map((el) => el.infoOriginator.name).join(', '))
														}
														itemToString={(item) => (item ? item && item.name : '')}
														items={this.state.appInfoOriginator.filter((item) => item.name !== 'SAP')}
														light={false}
														onChange={this.onChangeInfoOriginators}
														type="default"
														sortItems={(items) => items}
														initialSelectedItems ={(this.state.appInfoOriginator|| []).filter((e) => this.state.model.barrierKPIInfoOriginators?.find(el => el.infoOriginator.id === e.id) ? true : false)}
													/>
											)} 
							</FormGroup>
						</div>
					</Form>
				</ModalBody>
				<div className="bx--modal-footer">
					<Button className="button--max-width" kind="secondary" onClick={this.closeEditModal}>
						Cancel
					</Button>
					<Button className="button--max-width" kind="primary" onClick={this.insertReportBarrierKPI}>
						Save
					</Button>
				</div>
			</ComposedModal>
		);
	}

	handleChangePaging = (event) => {
		this.getPagedFilteredReportBarrierKpis(event);
	};

	render() {
		this.validator.purgeFields();

		const dataTableHeaders = [
			{ key: "code", header: "Code" },
			{ key: "section", header: "Section" },
			{ key: "description", header: "Description" },
			{ key: "frequency", header: "Frequency" },
			{ key: "months", header: "Months" },
			{ key: "incidentBarrierGroups", header: "Barrier Groups" },
			{ key: "incidentBarriers", header: "Barriers" },
			{ key: "infoOriginators", header: "Employer type" },
			{ key: "inUse", header: "In Use" },
		];

		const skeletonRowCount = this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount ? this.state.rowCount : 5;

		const paginationProps = () => ({
			page: this.state.currentPage || 1,
			totalItems: this.state.rowCount || 0,
			pageSize: this.state.pageSize || 10,
			pageSizes: [10, 20, 30, 40, 50],
			onChange: this.handleChangePaging,
		});

		const confirmDelProps = () => ({
			idToDelete: this.state.idToDelete,
			isDeleting: this.state.isDeleting,
			open: this.state.isDeleteModalOpen,
			onCloseConfirm: this.onCloseConfirm,
			deleteItem: this.deleteItem,
		});
		const itemToDelete = this.state.reportBarrierKPIListAll.find((el) => el.id == this.state.idToDelete);

		return (
			<AppContext.Consumer>
				{() => (
					<>
						<PageBreadCrumb linkTo={"/backoffice#Barrierkpi"} linkText={"BackOffice"} titleLeft={"Barrier KPI"} />
						<div className="mainContainer">
							<ConfirmAlertCustom {...confirmDelProps()}>
								{itemToDelete != null ? (
									<DataTable
										rows={[itemToDelete]}
										headers={dataTableHeaders.filter((h) => h.key != "name")}
										useZebraStyles={true}
										size="compact"
										render={({ rows, headers, getHeaderProps, getRowProps }) => (
											<TableContainer className="bx--grid--full-width deleting-item">
												<Table>
													<TableHead>
														<TableRow>
															{headers.map((header) => (
																<TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })}>
																	{header.header}
																</TableHeader>
															))}
														</TableRow>
													</TableHead>
													<TableBody>
														{rows.map((row) => (
															<TableRow {...getRowProps({ row })}>
																{row.cells.map((cell) => (
																	<RenderDataTableCell key={cell.id} cell={cell} header={headers.find((x) => x.key === cell.info.header)} />
																))}
															</TableRow>
														))}
													</TableBody>
												</Table>
											</TableContainer>
										)}
									/>
								) : null}
							</ConfirmAlertCustom>

							{this.state.isEditModalOpen ? this.renderDetailsForm() : ""}

							<TableToolbar>
								<form onSubmit={this.handleSearchFormSubmit} className="max-width" autoComplete="off">
									<Online>
										<Search readOnly light className="search cursor-pointer hiddenSearch" labelText="Search" placeHolderText="Search" id="search-1" onClick={this.toggleSearchForm} />
									</Online>
								</form>
								<Online>
									<Button onClick={this.toggleSearchForm} className="buttonPaddingIcon" renderIcon={Data16} iconDescription="Filter" />
									<Button onClick={() => this.downloadFile()} className="btn-notext" iconDescription=" " renderIcon={Download16}>
										{!this.state.isExportLoading ? "" : <Loading />}
									</Button>
								</Online>
								<Online>
									<Button onClick={() => this.openAddNewModal()} renderIcon={Add16}>
										Add New
									</Button>
								</Online>
							</TableToolbar>

							{this.state.isExportLoading ? <Loading /> : null}

							{this.renderSearchForm()}

							<DataTable
								rows={this.state.reportBarrierKPIListPaged}
								headers={dataTableHeaders}
								useZebraStyles={true}
								size="compact"
								render={({ rows, headers, getHeaderProps, getRowProps, getTableProps, getSelectionProps, selectedRows, getBatchActionProps }) => (
									<TableContainer className="bx--grid--full-width">
										{this.state.isLoadingEntity ? (
											<DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
										) : (
											<Table>
												<TableHead>
													<TableRow>
														{headers.map((header) => (
															<TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })}>
																{header.header}
															</TableHeader>
														))}
														<TableHeader className="align-center">Actions</TableHeader>
													</TableRow>
												</TableHead>
												<TableBody>
													{rows == null || rows.length === 0 ? (
														<NoRecordsPlaceholder colSpan={headers.length} />
													) : (
														rows.map((row) => (
															<TableRow {...getRowProps({ row })}>
																{row.cells.map((cell) => (
																	<RenderDataTableCell key={cell.id} cell={cell} header={headers.find((x) => x.key === cell.info.header)} />
																))}
																<TableCell key={"action-" + row.id} className="tableActions align-center">
																	<div>
																		<Online>
																			<Button onClick={() => this.getReportBarrierKPIForEdit(row.id)} size="small" renderIcon={Edit16} iconDescription="Edit" kind="ghost" />
																			<Button onClick={() => this.confirmDelete(row.id)} size="small" renderIcon={Delete16} iconDescription="Delete" kind="ghost" />
																		</Online>
																	</div>
																</TableCell>
															</TableRow>
														))
													)}
												</TableBody>
											</Table>
										)}
									</TableContainer>
								)}
							/>

							<div className="footer-pagination">
								<Pagination {...paginationProps()} />
							</div>
						</div>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}
